import { Link } from 'react-router-dom';
import { Home, Search, ArrowRight, Headphones, Shield } from 'lucide-react';
import { PORTAL_BASE } from '../config/portalPaths';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#0a0a0f] flex items-center justify-center p-4 relative overflow-hidden">
      {/* Animated background gradient orbs */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-[120px] animate-pulse"
          style={{ background: 'color-mix(in srgb, var(--color-primary, #EAB308) 8%, transparent)' }}
        />
        <div
          className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full blur-[100px] animate-pulse"
          style={{ background: 'color-mix(in srgb, var(--color-accent, #3B82F6) 6%, transparent)', animationDelay: '2s' }}
        />
      </div>

      <div className="relative z-10 max-w-lg w-full text-center space-y-8 page-transition-enter">
        {/* Animated 404 display */}
        <div className="relative">
          <h1
            className="text-[10rem] sm:text-[12rem] font-black leading-none tracking-tighter select-none"
            style={{
              background: `linear-gradient(135deg, var(--color-primary, #EAB308), color-mix(in srgb, var(--color-primary, #EAB308) 60%, black))`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              opacity: 0.15,
            }}
          >
            404
          </h1>
          {/* Floating icon overlay */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-bounce" style={{ animationDuration: '3s' }}>
              <div
                className="w-20 h-20 rounded-2xl flex items-center justify-center shadow-2xl border"
                style={{
                  background: 'linear-gradient(135deg, var(--color-primary, #EAB308), color-mix(in srgb, var(--color-primary, #EAB308) 70%, black))',
                  borderColor: 'color-mix(in srgb, var(--color-primary, #EAB308) 40%, transparent)',
                }}
              >
                <Search className="w-9 h-9 text-black/80" />
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-3 -mt-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100">
            Seite nicht gefunden
          </h2>
          <p className="text-gray-500 dark:text-gray-400 text-base leading-relaxed max-w-sm mx-auto">
            Die angeforderte Seite existiert nicht oder wurde verschoben. Versuchen Sie eine der folgenden Optionen.
          </p>
        </div>

        {/* Quick navigation cards */}
        <div className="grid gap-3 sm:grid-cols-3">
          <Link
            to="/agent"
            className="group flex flex-col items-center gap-2 p-4 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900/50 hover:border-gray-300 dark:hover:border-gray-700 hover:shadow-md transition-all duration-200 active:scale-[0.97]"
          >
            <Headphones className="w-6 h-6 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors" />
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Agent-Konsole</span>
            <ArrowRight className="w-3.5 h-3.5 text-gray-300 dark:text-gray-600 group-hover:translate-x-0.5 transition-transform" />
          </Link>
          <Link
            to="/admin"
            className="group flex flex-col items-center gap-2 p-4 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900/50 hover:border-gray-300 dark:hover:border-gray-700 hover:shadow-md transition-all duration-200 active:scale-[0.97]"
          >
            <Shield className="w-6 h-6 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors" />
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Administration</span>
            <ArrowRight className="w-3.5 h-3.5 text-gray-300 dark:text-gray-600 group-hover:translate-x-0.5 transition-transform" />
          </Link>
          <Link
            to={`${PORTAL_BASE}/login`}
            className="group flex flex-col items-center gap-2 p-4 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900/50 hover:border-gray-300 dark:hover:border-gray-700 hover:shadow-md transition-all duration-200 active:scale-[0.97]"
          >
            <Home className="w-6 h-6 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors" />
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Kundenportal</span>
            <ArrowRight className="w-3.5 h-3.5 text-gray-300 dark:text-gray-600 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </div>

        {/* Back to login */}
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm font-medium transition-colors hover:underline"
          style={{ color: 'var(--color-primary, #EAB308)' }}
        >
          ← Zurück zum Login
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;

